import { withRouter, RouteComponentProps } from 'react-router'

import context, { HistoryLocation, Location } from './context'
export type { HistoryLocation, Location }

interface ProviderProps extends RouteComponentProps<any> {
  children: React.ReactNode
}

export const ContextProvider = ({ history, location, children }: ProviderProps) => (
  <context.Provider
    value={{
      history,
      location,
    }}
  >
    {children}
  </context.Provider>
)

export default withRouter(ContextProvider)
